import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faEye, faRefresh, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import SidebarList from "./SidebarList";
import PageHeader from '../../components/common/PageHeader/index';
import FileList from "./FileList";
import FileDetail from "./FileList/FileDetail";
import { navigationAction } from "../../context/actions/navigationAction";
// import { documentLogListing } from '../../context/actions/document';

import { Button } from "reactstrap";
import { getDocuments, getDocumentsById, getDocumentsList, updateDocumentFile, updateDocumentFileStatus, deleteDocumentFile, appendDocumentsById, getElasticSearchFolders, getFileDoc, updateloanlist } from "../../context/actions/document";
import { getFileSetting } from "../../context/actions/fileSetting";


import { set_archive_filter, set_page } from "../../context/actions/general";
import '../../assets/css/common/document/index.scss';
import { useDispatch, useSelector } from "react-redux";
import LoadMore from "../../components/common/LoadMore";
import LoaderUI from "../../components/common/loader/index";
import { pagination, documentFilterItems, statusOptions,documentStatusOptions, toasterConfig } from '../../utils/constants';
import BackButton from "../../components/common/BackButton";
import FileSearchBlock from "./FileSearchBlock";
import SortFilterDropdown from "../../components/common/SortFilterDropdown";
import { navigationAction2 } from "../../context/actions/navigationAction2";
import { useHistory } from "react-router-dom";
import NoRecord from "../../components/common/NoRecord";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import FilterDropdown from "../../components/common/FilterDropdown";
import { SocketContext, backendSocket } from '../../context/actions/socket';
import FileQueueMsg from "./FileQueueMsg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TotalCount from "../../components/common/TotalCount";
import { getFile, rightsidebar } from "../../context/actions/document";
import AutoSaveDataModal from "../Dashboard/AutoSaveData/AutoSaveDataModal";
import { sortBy } from "lodash";

toast.configure();
const MySwal = withReactContent(Swal)
const Documents = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		window.onbeforeunload = function () {
			dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });  // on pageload set previously filter value to ''
		};

	}, []);
	const [elementPos, setElementPos] = useState(0)
	const { socket } = useContext(SocketContext);
	const user = useSelector((state) => state.user.user); // get current user details
	let queueCount = useSelector((state) => state.document.queueCount); // get current organization  queue files count
	let filter = useSelector((state) => state.document.filter); // get previously filter value
	let [search, setSearch] = useState('');
	let [sortByValue, setSortByValue] = useState('updatedAt');
	let [sortByName, setSortByName] = useState('Date');
	let [order, setOrder] = useState('-1');
	let [keyWord, setKeyWord] = useState('');
	const [sortBySelected, setSortBySelected] = useState('2');
	const [filterSelected, setFilterSelected] = useState(4);
	let [fileRefreshFlag, setFileRefreshFlag] = useState(false);
	let [folderRefreshFlag, setFolderRefreshFlag] = useState(false);
	const userData = useSelector((state) => state.user.user);
	const [disabled, setDisabled] = useState(false);
	const [sortFn, setSortFn] = useState(0);
	const [sidebarActivePacketIndex, setsidebarActivePacketIndex] = useState(0);
	const [label, setLabel] = useState('')
	let isArchived = useSelector((state)=>state.general.isArchive)

 

	useEffect(() => {
		setLoader(true);
		dispatch(set_page(1));
		setSearch(filter);
		setLabel('CR OR VR')
		dispatch(getDocuments({ fields: "name,loan_number", sort: 'updatedAt', order: -1, filter: filter, limit: paginations, page: page, label: 'CR OR VR' }, ((result) => { // for default folders filter 
			setLoader(false);
		})));

		dispatch(getFileSetting(((result) => {
			setLoader(false);
		})));

		if (user) {
			activeQueueStatus(user?.organization)
		}
	}, [user]);


	useEffect(() => {
		activeQueueStatus(user?.organization)
        dispatch(set_archive_filter(false))
	}, [fileRefreshFlag, folderRefreshFlag]);





	const navigationState = useSelector((state) => state.navigationReducer.isOn);
	const editorVisible = useSelector((state) => state.navigationReducer2.isOn2);


	const navigationHandler = () => {
		dispatch(navigationAction(!navigationState));
	}
	const sidebarEditorHandler = () => {
		dispatch(navigationAction2(!editorVisible));
	}

	const overClickHandler = () => {
		dispatch(navigationAction(false));
		dispatch(navigationAction2(false));
	}
	const history = useHistory();
	const [sidebarLoading, setSidebarLoading] = useState(false);
	const [sidebarLoadingLabel, setSidebarLoadingLabel] = useState('View More');
	const [sidbarLoadingButton, setSidbarLoadingButton] = useState(false);
	const [fileLoading, setFileLoading] = useState(false);
	const [fileLoadingLabel, setFileLoadingLabel] = useState('View More');
	const [fileLoadingButton, setFileLoadingButton] = useState(false);
	const [status, setStatus] = useState(false)
	const [page, setPage] = useState(pagination.page);
	const [paginations] = useState(pagination.limit);
	const [filePage, setFilePage] = useState(pagination.page);
	const [loader, setLoader] = useState(false);
	const [innerLoader, setInnerLoader] = useState(false);
	const documentMenu = useSelector((state) => state.document.documentMenu || []);
	let folders = useSelector((state) => state.document.folderRecords);
	let totalFolderRecords = useSelector((state) => state.document.totalFolderRecords);
	let totalDocRecords = useSelector((state) => state.document.totalDocRecords);
	const [docId, setDocId] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length ? documentMenu.docs[0]._id : null);
	const documentList = useSelector((state) => state.document.docRecords);
	const [tags, setTags] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length ? documentMenu.docs[0].tags : []);
	const [folder, setFolder] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu?.docs.length ? documentMenu?.docs[0] : null);
	const [documentDetail, setDocumentDetail] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length && documentMenu.docs[0].documents.length ? documentMenu.docs[0].documents[0] : {});
	const [selectedFileId, setSelectedFileId] = useState(documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length && documentMenu.docs[0].documents.length ? documentMenu.docs[0].documents[0]?._id : null);
	const [selectedIconId, setSelectedIconId] = useState(null);
	let [payload, setPayload] = useState({ limit: paginations, page: 1 });
	let [elasticPayload, setElasticPayload] = useState({});
	const [elasticSearchList, setElasticSearchList] = useState([]);
	let [focusSearchFlag, setFocusSearchFlag] = useState(false);
	let [labetStatus,setLabelStatus] = useState('')


	/**
	 * @description function intialization socket queue-<organization> file status realtime update
	 */
	const activeQueueStatus = (organization) => {
		console.log('part running documents (get docs) ....')
		socket.off(`queue-${organization}`).on(`queue-${organization}`, (res) => {
			if (res?.data?.processed === 100) {
				dispatch({ type: "UPDATE_QUEUE_COUNT" });
				dispatch({ type: "ENABLE BUTTON", data: true })
				dispatch(set_archive_filter(false))
				/*toast.dismiss();
				toast.success(res?.message, toasterConfig);
				setLoader(true);
				dispatch(getDocuments({ fields: "name,loan_number", filter: '', limit: paginations, page: page }, ((result) => {
					setSortBySelected(null)
					setFilterSelected(null)
					setLoader(false);
				})));*/
			}
		})
		socket.off(`cron-queue-${organization}`).on(`cron-queue-${organization}`, (res) => {
			if (!totalFolderRecords) {  // if no folders 
				setLoader(true);
				dispatch(getDocuments({ fields: "name,loan_number", filter: '', limit: paginations, page: page }, ((result) => {
					setSortBySelected(null)
					setFilterSelected(null)
					setLoader(false);

				})));
			} else {
				if (docId == res.data.folder) {
					dispatch({ type: "APPEND_TOTAL_RECORDS", data: 1, foldercount: res.foldercount });
					if (res?.data?.is_correct == 2) {
						dispatch({ type: "UPDATE_SELECTED_FOLDER", data: res.data });
					}
					if (!fileRefreshFlag) {
						toast.success('Some New Files have been added please click refresh button', toasterConfig);
						setFileRefreshFlag(true)
					}
				} else {
					if (res.foldercount > totalFolderRecords) {
						dispatch({ type: "APPEND_TOTAL_RECORDS", data: 0, foldercount: res.foldercount });
						if (!folderRefreshFlag) {
							toast.success('Some New Folder have been added please click refresh button', toasterConfig);
						}
					}
					setFolderRefreshFlag(true)
				}
			}
		})
	}


	/**
	 * @description method call to select document from leftside bar listing 
	 * @param {*} docId selected doc id 
	 * @returns 
	 */
	const _handleSelected = async (docId, docIndex) => {
		setElementPos(docIndex)
		setStatus(false);
		setLoader(true);
		setFilePage(pagination.page);
		setDocId(docId);
		dispatch(set_page(1));

		docIndex && docIndex != '' ? setsidebarActivePacketIndex(docIndex) : setsidebarActivePacketIndex(0)

		dispatch(getDocumentsById({ folder: docId, limit: paginations, page: 1, fields: 'name', filter: keyWord,label:labetStatus }, ((result) => {
			setLoader(false);
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(docDta && docDta?.type ? docDta?.type : {});
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)

		})));
		dispatch(navigationAction(!navigationState));
		if(labetStatus == 'Archived'){
		   dispatch(set_archive_filter(true))
		}else{
			dispatch(set_archive_filter(false))
		}
	};

	// refresh folders

	const refreshFolders = async () => {
		setFolderRefreshFlag(false);
		setFileRefreshFlag(false);
		setLoader(true);
		setInnerLoader(true)
		dispatch(set_page(1));
		dispatch(getDocuments({ limit: paginations, page: 1 }, ((result) => { //so that reset button shows original docs present in side bar (issue 392)
			setLoader(false);
			setInnerLoader(false);
			setSidbarLoadingButton(true);
			setPage(1);
		})));
	};

	const _changeFilesStatus = async (status) => {
		// setStatus(status)
		setLoader(true);
		setFilePage(pagination.page);
		dispatch(set_page(1));
		dispatch(getDocumentsById({ folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status, }, ((result) => {
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
			setLoader(false);
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));

		dispatch(set_archive_filter(status))
		dispatch(navigationAction(!navigationState));
	};


	/**
		 * @description method call to search documents from leftside bar listing 
		 * @param {*} val 
		 * @returns 
		 */

	const _advanceFilter = async (val) => {
		setStatus(false)
		setSortFn(0)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setFilePage(1);
		setPage(1);
		// setSortByValue('updatedAt');
		// setSortByName('Date');
		// setOrder('-1');
		let advFilter = documentFilterItems[val];
		setLabel(advFilter?.label)
		//	setValue(advFilter)
		if(advFilter?.label == "Archived")
		{
			delete payload?.is_correct;
			delete payload?.is_verified;	
			dispatch(set_archive_filter(true))
			payload = { ...payload, ...advFilter, docFilter: keyWord, page: 1, sort: sortByValue, order: order }
			setLabelStatus("Archived")
		}else{
			setLabelStatus("")
			dispatch(set_archive_filter(false))
			payload = { ...payload, ...advFilter, ...{ 'deleted': status }, docFilter: keyWord, page: 1, sort: sortByValue, order: order }
		}
		//setValue(payload)
		elasticPayload = { ...payload, ...advFilter }
		setElasticSearchList([]);
		setElasticPayload(elasticPayload);
		setPayload(payload);
		setInnerLoader(true);
		setsidebarActivePacketIndex(0)
		if (val.trim()) {
			elasticPayload = { ...elasticPayload, name: val }
			setElasticPayload(elasticPayload)
			 dispatch(getElasticSearchFolders(elasticPayload, ((result) => {
				setInnerLoader(false);
				setElasticSearchList(result?.hits?.hits);
				setFocusSearchFlag(true);
			})));
		}
		dispatch(getDocuments(payload, ((result) => {
			setInnerLoader(false);
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
			setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		}))); 

	}


	/**
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */

	const __advanceFilter = async (sortBy, order, val) => {
		setSortFn(1)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setFilePage(1);
		setPage(1);
		setSortByValue(sortBy);
		setOrder(order)
		// setSortByValue('updatedAt');
		// let advFilter = documentFilterItems[val]
		setSortByName('Date');
		// setOrder('-1');
		payload = { ...payload, ...{ 'deleted': status }, docFilter: keyWord, sort: sortBy, order: order, page: 1 }

		setPayload(payload);
		setInnerLoader(true);
		setsidebarActivePacketIndex(0)

		dispatch(getDocuments(payload, ((result) => {
			setInnerLoader(false);
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
			setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		})));


		dispatch(getDocuments(payload, ((result) => {
			setInnerLoader(false);
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
			setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);
		})));

	}

	/**
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */
	const _docSearch = async (val, moreInfoObj) => {
		let filterWord = moreInfoObj && moreInfoObj.keyword ? moreInfoObj.keyword : val
		setStatus(false)
		setFilePage(1);
		setPage(1);
		setInnerLoader(true);
		setSearch(filterWord);
		// setSortByValue('createdAt');
		setSortByName('Date');
		// setOrder('-1');
		setsidebarActivePacketIndex(0)

		payload = { ...payload, fields: "name,loan_number", filter: filterWord, docFilter: keyWord, page: 1 }
		setPayload(payload)
		dispatch(getDocuments(payload, ((result) => {
			setInnerLoader(false);
			if (moreInfoObj && moreInfoObj !== undefined && moreInfoObj._id && moreInfoObj._id != '' && result.docs !== undefined && result.docs.length) {

				let elementPos = result.docs.map(function (doc) { return doc._id; }).indexOf(moreInfoObj._id);
				if (elementPos && elementPos !== -1) _handleSelected(moreInfoObj._id, elementPos);
			}

		})));
	};
	/**
	* @description funnction call to search value by elasticsearc
	* @param {string} param search value
	 */

	const _elasticSearch = async (val) => {
		if (val.trim()) {
			elasticPayload = { ...elasticPayload, name: val }
			setElasticPayload(elasticPayload)
			await dispatch(getElasticSearchFolders(elasticPayload, ((result) => {
				setInnerLoader(false);
				let results = result?.hits?.hits.filter((item) => {
					if (item?._source?.ml_status == true) {
						return item
					}

				})
				setElasticSearchList(results);
				setFocusSearchFlag(true);
			})));
		} else {

			setElasticSearchList([])
		}

	};

	const _selectedDoc = async (id) => {
		setLoader(true);
		setSelectedFileId(id);
		const doc = await documentList.find(({ _id }) => _id === id);
		setDocumentDetail(doc);
		setLoader(false);
	};

	const _sortBySelected = async (val) => {
		setSortBySelected(val);

	};


	const _filterSelected = async (val) => {
		setFilterSelected(val);

	};


	/**
	 * @description method call to loadmore folders in leftside bar listing 
	 * @param {*} activePage 
	 * @returns 
	 */

	const _handlePageChange = (activePage) => {
		setPage(activePage);
		setSidebarLoading(true);
		setSidebarLoadingLabel('loading');
		payload = { ...payload, page: activePage, docFilter: keyWord, order: order, sort: sortByValue }
		setPayload(payload);
		dispatch(getDocumentsList(payload, ((result) => {
			setSidebarLoading(false);
			setSidebarLoadingLabel('View More');
		})));
	}

	const _resetFilter = () => {
		setFileRefreshFlag(false);
		setFolderRefreshFlag(false);
		setStatus(false)
		setFileSearch(false)
		setKeyWord('');
		setFilePage(1);
		setPage(1);
		setElasticSearchList([]);
		setFocusSearchFlag(false);
		// setSortByValue('createdAt');
		setSortByName('Date');
		// setOrder('-1');
		payload = { limit: paginations, page: 1 }
		setPayload(payload);
		setElasticPayload({});
		setInnerLoader(true);
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: '' });
		setSearch('')
		setsidebarActivePacketIndex(0)
		dispatch(getDocuments(payload, ((result) => {
			setInnerLoader(false);
			setTags(result.docs !== undefined && result.docs.length ? result.docs[0].tags : [])
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0] : {})
			setSelectedFileId(result.docs !== undefined && result.docs.length && result.docs[0].documents.length ? result.docs[0].documents[0]?._id : null);

		})));
	}

	/**
	 * @description method call to loadmore document files 
	 * @param {*} activePage 
	 * @returns 
	 */

	const _handleFilePageChange = (activePage) => {
		//dispatch(pageLimit(activePage))
		setFilePage(activePage);
		dispatch(set_page(activePage));
		setFileLoading(true);
		setFileLoadingLabel('loading');
		dispatch(appendDocumentsById({ folder: docId, sort: sortByValue, order: order, fields: "name", filter: '', limit: paginations, page: activePage, deleted: status }, ((result) => {
			setFileLoading(false);
			setFileLoadingLabel('View More');
		})));

	}


	/**
	 * @description method call to refresh document files 
	 * @param {*} activePage 
	 * @returns 
	 */

	const refreshFiles = () => {
		setFileRefreshFlag(false);
		setLoader(true);
		setFilePage(1);

		dispatch(set_page(1));
		dispatch(getDocumentsById({ folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status }, ((result) => {
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
			setLoader(false);

			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));
		dispatch(navigationAction(!navigationState));

	}



	/**
	 * @description method call to soft delete  document file
	 * @param {*} id  document file id
	 * @returns 
	 */
	const _deleteDocument = (id) => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to archive this document",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, archive it!'
		}).then((result) => {
			if (result.isConfirmed) {
				console.log("sdasdasdadas")
				dispatch(deleteDocumentFile({ id: id }, ((result) => {
					if (result) {
						dispatch(getDocumentsById({ folder: docId}, (result)=>{
							if(result.totalDocs  == 0){
							dispatch(updateloanlist({folder: docId,record_active:false}, (response)=>{
                                dispatch(getDocuments(payload, (result)=>{}))
							}))
							}
						}))
						_handleSelected(docId, elementPos);
					}
				})))
				MySwal.fire(
					'Archived!',
					'Your document has been archived.',
					'success'
				)
			}
		})
	}

	const editDocument = () => {
		setDisabled(true);
		dispatch({ type: "ISLOADING", data: true });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: search });
		dispatch(rightsidebar('D'));
		dispatch(
			getFileDoc({ docId: documentDetail._id, Au: null, pageNumber: 1 }, (result) => {
				if (result) {
					history.push("/documentDetail");

				}
				setDisabled(false)
			})
		);
	}


	/**
	 * @description method call to restore  document file
	 * @param {*} id  document file id
	 * @returns 
	 */
	const _restoreDocument = (id) => {
		MySwal.fire({
			title: 'Are you sure?',
			text: "You want to restore this document",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes, restore it!'
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(updateDocumentFileStatus({ deleted: false, id: id }, ((result) => {
					dispatch(getDocumentsById({ folder: docId, sort: sortByValue, order: order, limit: paginations, page: 1, deleted:true}, (result)=>{
						   const array = result.docs;
						   const totaldoc_arr = array.find((item)=>item?.deleted == true)
							if (!totaldoc_arr){
							dispatch(updateloanlist({folder: docId,record_active:true}, (result)=>{
								if(result){
                                  dispatch(getDocuments(payload, (result)=>{
					             }))
								}
							}))
							}
						}))
					_changeFilesStatus(true);
					
				})));
				MySwal.fire(
					'Restore!',
					'Your document has been restored.',
					'success'
				)
			}
		})

	}
	/**
	  * @description method call to change favorite/unfavorite  document file
	  * @param {*} id  document file id
	  * @returns 
	  */
	const _favUnfavDoc = (favorite, id) => {
		setSelectedIconId(id);
		let data = { favorite: favorite ? 0 : 1, id: id };
		dispatch(updateDocumentFile(data, (() => {
			setSelectedIconId(null);
		})));
	}

	const backClick = () => {
		history.push("/dashboard");
	}

	useEffect(() => {
		return () => {
			dispatch(navigationAction(false));
			dispatch(navigationAction2(false));
		}
	}, [documentMenu, paginations, page, filePage, dispatch]);

	useEffect(() => {

		if (totalFolderRecords && totalFolderRecords > paginations * page) {
			setSidbarLoadingButton(true)
		} else {
			setSidbarLoadingButton(false)
		}
		if (totalDocRecords && totalDocRecords > paginations * filePage) {
			setFileLoadingButton(true)
		} else {
			setFileLoadingButton(false)
		}

	});

	useEffect(() => {
		if (documentMenu !== undefined && documentMenu.docs !== undefined && documentMenu.docs.length) {
			setDocId(documentMenu.docs[0]._id);
			setTags(documentMenu.docs[0].tags);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(documentMenu.docs[0].documents[0]);
			setSelectedFileId(documentMenu.docs[0].documents[0]?._id);
		}
	}, [documentMenu]);

	const focusSearch = (val) => {
		setFocusSearchFlag(val);
	}

	useEffect(() => {
		const handleWindowClick = () => {
			setFocusSearchFlag(false)
		}
		if (focusSearchFlag) {
			window.addEventListener('click', handleWindowClick);
		}
	}, [focusSearchFlag]);

	const [fileSearch, setFileSearch] = useState(false);
	const fileSearchCallback = (value) => {
		setFileSearch(value)
	}
	const _sortBy = (key, param, ord) => {
		setSortByName(key);
		setSortByValue(param);
		setOrder(ord);
		setLoader(true);
		setFilePage(pagination.page);
		dispatch(set_page(1));
		dispatch(getDocumentsById({ folder: docId, sort: param, order: ord, limit: paginations, page: 1, deleted: status, filter: keyWord, fields: "name" }, ((result) => {
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
			setLoader(false);
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));
		dispatch(navigationAction(!navigationState));


	}
	const _handleFileSearch = (val) => {
		setLoader(true);
		setFilePage(pagination.page);
		dispatch(set_page(1));
		setKeyWord(val);
		dispatch(getDocumentsById({ folder: docId, fields: "name", filter: val, sort: sortByValue, order: order, limit: paginations, page: 1, deleted: status }, ((result) => {
			dispatch({ type: "LIST_DOCUMENT", data: result.docs, totalDocRecords: result.totalDocs, folder: docId });
			setLoader(false);
			let docDta = folders.find(({ _id }) => _id === docId);
			setTags(docDta && docDta.tags !== undefined ? docDta.tags : []);
			setFolder(documentMenu.docs[0]?.type);
			setDocumentDetail(result && result.docs.length ? result.docs[0] : {})
			setSelectedFileId(result && result.docs.length ? result.docs[0]._id : null)
		})));
		dispatch(navigationAction(!navigationState));

	}

	const [isAddModelOpen, setIsModelOpen] = useState(false);

	return (
		<>

			<AutoSaveDataModal showModel={isAddModelOpen} setShowModel={setIsModelOpen}

			/>

			<div className="documents-wrapper d-flex flex-fill overflow-auto position-relative">

				<div
					className={`sidebarListOverlay ${(navigationState || editorVisible) ? 'active' : ''}`} onClick={overClickHandler}></div>
				<div className=
					{`left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? 'active' : ''}
				`}>
					{folders &&
						<SidebarList _resetFilter={_resetFilter} sidebarLoading={sidebarLoading} sidebarLoadingLabel={sidebarLoadingLabel} sidbarLoadingButton={sidbarLoadingButton} page={page} handlePageChange={(page) => _handlePageChange(page)} list={folders} handleSelectedAction={(id, docIndex) => _handleSelected(id, docIndex)} _filter={_advanceFilter} __filter={(sortBy, order, v) => __advanceFilter(sortBy, order, v)} search={(val, moreInfoObj) => _docSearch(val, moreInfoObj)} menu="document" sortFn={sortFn} _innerLodder={innerLoader} handleElasticSearch={(val) => _elasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} _focusSearch={(val) => focusSearch(val)} filter={filter} totalFolderRecords={totalFolderRecords} _sidebarActivePacketIndex={sidebarActivePacketIndex} sortBySelected={sortBySelected} _sortBySelected={_sortBySelected} filterSelected={filterSelected} _filterSelected={_filterSelected} refreshFolders={refreshFolders} folderRefreshFlag={folderRefreshFlag} />
					}
				</div>
				<div className="mid-col d-flex flex-column flex-fill overflow-auto">
					<PageHeader
						className={`responsive-menu-btn document-file-header ${keyWord ? 'input-has-value' : ''}
					${fileSearch ? 'active' : ''} ${queueCount !== 0 && 'queue-files-on'}`}>
						<div className="left-col d-flex align-items-center flex-fill header-filter-rw">
							<span className="ttl">Files</span>
							{/* {queueCount !== 0 && <FileQueueMsg className="desktop" queueCount={queueCount} />} */}
						</div>
						<div className="ms-auto right-col">
							<div className="header-filter-inner d-flex align-items-center">
								<div className="left-colum d-flex align-items-center">
									<FileSearchBlock fileSearchCallback={fileSearchCallback} _handleFileSearch={(val) => _handleFileSearch(val)} keyWord={keyWord} _setKeyword={(val) => setKeyWord(val)} className="col-cell" />
									<SortFilterDropdown _sortBy={(key, val, order) => _sortBy(key, val, order)} className="col-cell" sortByName={sortByName} />
									<FilterDropdown className="desktop col-cell" options={documentStatusOptions} val={isArchived} handleVal={(val) => _changeFilesStatus(val)}  isArchived={isArchived}/>
								</div>
								<div className="right-colum d-flex align-items-center">
									<Button color="link" className="toggle-btn" onClick={navigationHandler}>
										<FontAwesomeIcon icon={faBars} />
									</Button>
									<Button color="link" className="toggle-btn" onClick={sidebarEditorHandler}>
										<FontAwesomeIcon icon={faEye} />
									</Button>
									<BackButton className="ms-auto" onClick={() => backClick()} />
								</div>
							</div>
						</div>
					</PageHeader>
					{/* <FileNotification /> */}
					<div className="count-cell-Wrapper d-flex align-items-center">
						<div className="left-col">
							{queueCount !== 0 && <FileQueueMsg className="desktop" queueCount={queueCount} />}
						</div>
						<div className="right-col ms-auto">
							<div className="refresh-list-hd d-flex align-items-center">
								{<TotalCount className="ms-auto" name="Total Files" records={totalDocRecords} />}
								<div className="rightCol ms-auto">
									{
										fileRefreshFlag && <span data-toggle="tooltip" data-placement="top" title="New File" className="new-file-indicator">
											<img className="img-fluid" src={require('../../assets/img/indicator.png')} alt="Indicator" />
										</span>
									}
									<Button
										onClick={refreshFiles}
										//onClick={_resetFilter}
										data-toggle="tooltip" data-placement="top" title="Reload" color="link" className="refresh-btn d-inline-flex align-items-center justify-content-center">
										<FontAwesomeIcon icon={faRefresh} />
										{/* <span>Refresh</span> */}
									</Button>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-blc flex-fill overflow-auto position-relative">
						{!loader ? documentList?.length ? (
							<FileList list={documentList} selectedDoc={(id) => _selectedDoc(id)} favUnfavDoc={(status, id) => _favUnfavDoc(status, id)} selectedFileId={selectedFileId} selectedIconId={selectedIconId} fileStatus={status} _editDocument={editDocument} label={label} />
						) : (
							<NoRecord />
						) : (
							<LoaderUI message FullWindow={false} inContainer={true} />
						)}
					</div>
					{fileLoadingButton && <LoadMore loading={fileLoading} page={filePage} label={fileLoadingLabel} __handlePageChange={(activePage) => _handleFilePageChange(activePage)} />}
				</div>
				<div className={`
				right-col overflow-auto sidebar-editor-col d-flex flex-column  
				${editorVisible ? 'active' : ''}
				`
				}>
					<div className="inner-content overflow-auto">
						{!loader && documentList?.length && documentDetail ? (
							<FileDetail document={documentDetail} tags={tags} folder={folder} deleteDocument={(id) => _deleteDocument(id)} restoreDocument={(id) => _restoreDocument(id)} search={search} />
						) : (
							null
						)}
					</div>
					{documentDetail && !documentDetail.deleted && documentDetail._id &&
						<div className="file-detail-btns d-flex align-items-center mt-auto">
							<div className="cell">
								<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => editDocument()}>Edit</Button>
							</div>
							<div className="cell">
								<Button color="danger" disabled={!userData?.purchase_advice && folder?.type === 'purchase advice'} onClick={() => _deleteDocument(documentDetail && documentDetail._id)}>Archive</Button>
							</div>
						</div>}
					{documentDetail && documentDetail.deleted && <div className="file-detail-btns d-flex align-items-center mt-auto">
						<div className="cell">
							<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => _restoreDocument(documentDetail._id)}>Restore</Button>
						</div>

					</div>}

				</div>
			</div>
		</>
	)
};
export default Documents;